/// <reference path="../Page.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    export class ArticlePage extends Page {

        protected createByType(data: Map<any, any>, main: Tag) {
            const t = data.get("t");
            switch (t) {
                default :
                    super.createByType(data, main);
                    break;
            }
        }

        protected createSelf() {
            super.createSelf();
            this.addClass("pa-a");
        }

        public getTagName(): string {
            return "article";
        }
    }

}
